import React from 'react';
import DashboardMainContainer from '../common/Containers/DashboardMainContainer';
import {
  AdminMainText,
  AdminSupportingText,
  AdminStatusBadge,
} from '../../sections/AdminDashboard/shared/adminUx';
import { AdminWidgetHeader } from './AdminWidgetChrome';

const LastLoginWidget = ({ className = 'masonry-item w-[400px] h-[300px] flex flex-col' }) => {
  const loginData = {
    lastLoginDate: 'Nov 31, 2024',
    lastLoginTime: '2:15 PM',
    ipAddress: '192.168.232.7',
    location: 'Melbourne',
    device: 'Laptop',
    isTrusted: true,
  };

  const rows = [
    {
      label: 'Last Login',
      value: `${loginData.lastLoginDate} ${loginData.lastLoginTime}`,
      icon: (
        <path
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeWidth={2}
          d="M12 8v4l3 3m6-3a9 9 0 11-18 0 9 9 0 0118 0z"
        />
      ),
    },
    {
      label: 'IP Address',
      value: loginData.ipAddress,
      icon: (
        <path
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeWidth={2}
          d="M3.055 11H5a2 2 0 012 2v1a2 2 0 002 2 2 2 0 012 2v2.945M8 3.935V5.5A2.5 2.5 0 0010.5 8h.5a2 2 0 012 2 2 2 0 104 0 2 2 0 012-2h1.064M15 20.488V18a2 2 0 012-2h3.064M21 12a9 9 0 11-18 0 9 9 0 0118 0z"
        />
      ),
    },
    {
      label: 'Location',
      value: loginData.location,
      icon: (
        <>
          <path
            strokeLinecap="round"
            strokeLinejoin="round"
            strokeWidth={2}
            d="M17.657 16.657L13.414 20.9a1.998 1.998 0 01-2.827 0l-4.244-4.243a8 8 0 1111.314 0z"
          />
          <path
            strokeLinecap="round"
            strokeLinejoin="round"
            strokeWidth={2}
            d="M15 11a3 3 0 11-6 0 3 3 0 016 0z"
          />
        </>
      ),
    },
  ];

  return (
    <DashboardMainContainer className={className}>
      <AdminWidgetHeader title="Last Login" />

      <div className="flex-1 p-4 space-y-4">
        {rows.map((row) => (
          <div key={row.label} className="flex items-center gap-3">
            <svg className="w-5 h-5 text-offblack shrink-0" fill="none" stroke="currentColor" viewBox="0 0 24 24">
              {row.icon}
            </svg>
            <div className="flex-1 min-w-0">
              <AdminMainText className="text-offblack block">{row.label}</AdminMainText>
              <AdminSupportingText className="text-offblack">{row.value}</AdminSupportingText>
            </div>
          </div>
        ))}

        <div className="flex items-center gap-3">
          <svg className="w-5 h-5 text-offblack shrink-0" fill="none" stroke="currentColor" viewBox="0 0 24 24">
            <path
              strokeLinecap="round"
              strokeLinejoin="round"
              strokeWidth={2}
              d="M9.75 17L9 20l-1 1h8l-1-1-.75-3M3 13h18M5 17h14a2 2 0 002-2V5a2 2 0 00-2-2H5a2 2 0 00-2 2v10a2 2 0 002 2z"
            />
          </svg>
          <div className="flex-1 min-w-0">
            <AdminMainText className="text-offblack block">Device</AdminMainText>
            <div className="flex items-center justify-between gap-2">
              <AdminSupportingText className="text-offblack">{loginData.device}</AdminSupportingText>
              {loginData.isTrusted && (
                <button
                  type="button"
                  className="group relative shrink-0 min-w-[7.5rem]"
                  aria-label="Trusted device — hover to revoke"
                >
                  <span className="block group-hover:invisible">
                    <AdminStatusBadge status="Active" label="Trusted Device" className="bg-primaryblue" />
                  </span>
                  <span className="absolute inset-0 hidden group-hover:flex items-center justify-center">
                    <AdminStatusBadge status="At Risk" label="Revoke" className="bg-alertred" />
                  </span>
                </button>
              )}
            </div>
          </div>
        </div>
      </div>
    </DashboardMainContainer>
  );
};

export default LastLoginWidget;
